import * as XLSX from "xlsx";

function normalizeHeader(value, index) {
  const raw = String(value ?? "").trim();
  if (raw) return raw;
  return `kolom_${index + 1}`;
}

export async function parseXlsxFile(file) {
  if (!(file instanceof File)) {
    throw new Error("Geen geldig XLSX-bestand ontvangen.");
  }

  const buffer = await file.arrayBuffer();
  if (!buffer || buffer.byteLength === 0) {
    throw new Error("XLSX-bestand is leeg of onbruikbaar.");
  }

  let workbook;
  try {
    workbook = XLSX.read(buffer, { type: "array" });
  } catch {
    throw new Error("XLSX-bestand kon niet worden gelezen.");
  }

  const firstSheetName = Array.isArray(workbook?.SheetNames) ? workbook.SheetNames[0] : "";
  if (!firstSheetName) {
    throw new Error("XLSX-bestand bevat geen werkblad.");
  }

  const sheet = workbook.Sheets[firstSheetName];
  if (!sheet) {
    throw new Error("Eerste werkblad in XLSX is onbruikbaar.");
  }

  const matrix = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    raw: false,
    defval: "",
    blankrows: false,
  });

  const rowsClean = (Array.isArray(matrix) ? matrix : [])
    .map((row) => (Array.isArray(row) ? row.map((cell) => String(cell ?? "").trim()) : []))
    .filter((row) => row.some((cell) => cell !== ""));

  if (rowsClean.length < 2) {
    throw new Error("XLSX bevat geen bruikbare dataregels.");
  }

  const headers = rowsClean[0].map((header, index) => normalizeHeader(header, index));
  const validHeaders = headers.filter((value) => String(value).trim() !== "");
  if (validHeaders.length === 0) {
    throw new Error("XLSX-kopregel is onbruikbaar.");
  }

  const rows = rowsClean
    .slice(1)
    .map((values) => {
      const row = {};
      headers.forEach((header, index) => {
        row[header] = String(values[index] || "").trim();
      });
      return row;
    })
    .filter((row) => Object.values(row).some((value) => String(value || "").trim() !== ""));

  if (rows.length === 0) {
    throw new Error("XLSX bevat geen bruikbare dataregels.");
  }

  return {
    headers,
    rows,
    sheetName: firstSheetName,
  };
}
